export const PREVIOUS_OWNERS_FILTER_NAME = 'previousOwnersFilter';

export const PREVIOUS_OWNERS_SECTION = 'previous_owners';

export interface PreviousOwnersOption {
	from: number | null;
	label: string;
	to: number | null;
	value: string;
}

export const PREVIOUS_OWNERS_OPTIONS: PreviousOwnersOption[] = [
	{ from: null, label: 'Any', to: null, value: 'any' },
	{ from: null, label: 'None', to: 0, value: 'none' },
	{ from: null, label: 'Up to 1', to: 1, value: 'up-to-1' },
	{ from: null, label: 'Up to 2', to: 2, value: 'up-to-2' },
	{ from: null, label: 'Up to 3', to: 3, value: 'up-to-3' },
	{ from: 4, label: '4 or more', to: null, value: '4-or-more' },
];

export const getSelectedOption = (
	from: number | null | undefined,
	to: number | null | undefined,
): PreviousOwnersOption => {
	const normalizedFrom = from ?? null;
	const normalizedTo = to ?? null;

	const match = PREVIOUS_OWNERS_OPTIONS.find((option) => option.from === normalizedFrom && option.to === normalizedTo);

	return match ?? PREVIOUS_OWNERS_OPTIONS[0];
};
